import { detect } from 'detect-browser';
import * as React from 'react';
import * as uuid from 'uuid';
import AnswerVideoFrame from '../../../components/AnswerVideoFrame';
import RecordPage from '../../../components/RecordPage';
import UploadVideo from '../../../components/UploadVideo';
import styled from '../../../styled-components';
import { Answer } from '../../../types/api';
import { ApplicationState, Question } from '../types';
import ViewOwnVideo from './ViewOwnVideo';

interface AnswerVideoBoxProps {
    onNewAnswer: (answer: Answer) => void;
    onRetry: (answer: Answer) => void;
    question: Question;
    applicationId: string;
    applicationState: ApplicationState;
    answer?: Answer;
    retry: boolean;
}

const Wrapper = styled.div`
    margin-bottom: 1em;
`;

const AnswerVideoBox: React.FC<AnswerVideoBoxProps> = props => {
    const onNewVideoUpload = (id: string) => {
        const newAnswer: Answer = {
            id: (props.answer && props.answer.id) || uuid.v4(),
            questionId: props.question.id,
            videoLink: id
        };
        props.onNewAnswer(newAnswer);
    };

    const onRetry = () => {
        if (props.answer) {
            props.onRetry(props.answer);
        }
    };

    const supportedBrowsers = ['firefox', 'chrome', 'opera'];
    const isRecordingSupported = supportedBrowsers.indexOf(detect().name) > -1;

    return (
        <Wrapper>
            <h2>Your Answer</h2>
            {props.retry || props.answer === undefined ? (
                isRecordingSupported ? (
                    <RecordPage
                        tags="candidate_video"
                        folder={'applications/' + props.applicationId}
                        onNewVideoUpload={onNewVideoUpload}
                    />
                ) : (
                    <UploadVideo
                        tags="candidate_video"
                        folder={'applications/' + props.applicationId}
                        onNewVideoUpload={onNewVideoUpload}
                    />
                )
            ) : (
                <AnswerVideoFrame>
                    <ViewOwnVideo
                        question={props.question}
                        answer={props.answer}
                        onRetry={onRetry}
                        applicationState={props.applicationState}
                    />
                </AnswerVideoFrame>
            )}
        </Wrapper>
    );
};

export default AnswerVideoBox;



// WEBPACK FOOTER //
// ./src/scenes/candidate/components/AnswerVideoBox.tsx